import React, { Component } from 'react'
import { connect } from 'react-redux'
import StaticBox from '../containers/StaticBox'
import FlowTable from './FlowTable'
import Select from 'react-select'
import { notify } from 'helpers'
import API from 'API'

class OverviewTable extends Component {
  constructor (props) {
    super(props)
    this.state = {
      data: [],
      loading: true,
      count: this.props.count || 20,
      totalResults: 0,
      conditions: null,
      activePage: 1,
      filter: ''
    }
  }
  componentDidMount () {
    this.getData()
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.activePage && nextProps.activePage !== this.state.activePage) this.setState({activePage: nextProps.activePage}, this.getData)
    if (JSON.stringify(nextProps.conditions) !== JSON.stringify(this.props.conditions)) this.setState({conditions: nextProps.conditions}, this.getData)
  }
  onPageChange (e) {
    this.setState({activePage: e, loading: true}, this.getData)
  }
  async getData () {
    this.setState({loading: true})
    var result = await API.list(this.props.endpoint, Object.assign(this.props.id ? {objectid: this.props.id} : {}, {
      parameters: Object.assign(
        {},
        {
          pagination: true,
          'pagination.size': this.state.count,
          'pagination.from': (this.state.count * (this.state.activePage - 1))
        },
        !this.state.conditions && this.props.filterKey && this.state.filter.length ? {
          'condition': true,
          'condition.values': {
            'items': [{
              'key': this.props.filterKey,
              'value': this.state.filter,
              'operator': 'CONTAINS'
            }]
          }
        } : {},
        this.state.conditions ? {
          'condition': true,
          'condition.values': this.state.conditions
        } : {},
        this.props.sortingKey ? {
          'sorting': true,
          'sorting.by': this.props.sortingKey,
          'sorting.order': this.props.sortingOrder || 'DESC'
        } : {})
    }))
    if (!result.success) return notify.alert(result.message, result.errorid, 'error')
    this.setState({loading: false, data: result.data, totalResults: result.count})
  }
  filterTimeout () {
    this.setState({loading: true})
    clearTimeout(this.state.timer)
    this.state.timer = setTimeout(() => this.getData(), 300)
  }
  render () {
    return (
      <StaticBox cols='12' icon={this.props.icon} title={this.props.title} filter={this.props.filterKey ? e => this.setState({filter: e.target.value, activePage: 1}, this.filterTimeout) : false}>
        <FlowTable className='count-table' loading={this.state.loading} data={this.state.data.map(data => this.props.format(data))} totalResults={this.state.totalResults} activePage={this.state.activePage} count={this.state.count} onPageChange={e => this.onPageChange(e)}>
          {{...this.props.children}}
        </FlowTable>
        <Select
          className='table-pagination-select'
          searchable={false}
          labelKey='value'
          valueKey='value'
          clearable={false}
          value={this.state.count}
          options={[{value: 5}, {value: 10}, {value: 20}, {value: 30}, {value: 50}, {value: 100}]}
          onChange={(num) => this.setState({count: num.value}, this.getData)} />
      </StaticBox>
    )
  }
}
// eslint-disable-next-line
OverviewTable = connect(state => state.siteReducer)(OverviewTable)
export default OverviewTable



// WEBPACK FOOTER //
// ./src/components/basic/tables/OverviewTable.js